import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DraggableModal from '../../components/commonAction/DraggableModal';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { inboxPage } from '../_redux/actions/inboxActions';
import { outboxPage } from '../_redux/actions/outboxActions';

interface CheckLocksBeforeEditModalProps {
    show: boolean;
    close: () => void;
    onCancel: () => void;
    handleMultiplePage: () => void;
    selectedDocID: string | number;
    processId: string | number;
    statusId: string | number;
    editURL: string;
    lockedDocIds?: Array<string | number>;
    docIdsToEdit?: Array<string | number>;
};

const CheckLocksBeforeEditModal: React.FC<CheckLocksBeforeEditModalProps> = ({
    show,
    close,
    onCancel,
    handleMultiplePage,
    lockedDocIds,
    docIdsToEdit,
    editURL,
    selectedDocID,
    processId,
    statusId,
}) => {

    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    const hasDocsToEdit = (docIdsToEdit?.length ?? 0) > 0;
    const description = hasDocsToEdit
        ? "Some of the documents are locked. Do you want to continue without the locked documents?"
        : "You can't proceed because all documents in the request are locked by other users";
    const details = lockedDocIds && lockedDocIds.length > 0
        ? `Locked documents: ${lockedDocIds.join(', ')}`
        : null;
    
    const redirectToMergeSplitPage = () => {
        handleMultiplePage();
        close();

        const path = String(location.pathname);
        const isDetail =
            path.includes('inbox/detail') || path.includes('outbox/detail');

        if (isDetail) {
            dispatch(inboxPage({ multiple_edit_page: true }));
            dispatch(outboxPage({ multiple_edit_page: true }));

            dispatch(inboxPage({ related_doc_detail: false }));
            dispatch(outboxPage({ related_doc_detail: false }));

            history.push({
                pathname: editURL,
                state: {
                    selectedDocID: selectedDocID ?? undefined,
                    processId: processId ?? undefined,
                    statusId: statusId ?? undefined,
                },
            });
            return;
        }

        history.push(editURL);
    };
    return (
        <DraggableModal
            show={show}
            animation={false}
            onHide={onCancel}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header
                closeButton
                className="modal-header d-block justify-content-start"
            >
                <Modal.Title
                    className="d-flex align-items-stretch justify-content-between"
                >
                    <div style={{ color: 'red' }}>
                        <i
                            style={{ color: 'red' }}
                            title="Edit"
                            className="fas fa-page-break mr-3"
                        />
                        Edit Documents Restriction
                    </div>

                    <i
                        title="Close"
                        className="fa-light fa-xmark d-flex justify-content-end align-items-center"
                        aria-hidden="true"
                        onClick={onCancel}
                    />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="deletes">
                <p>{description}</p>
                {(details) && (
                    <div className="text-muted">
                        {details && <div>{details}</div>}
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="d-block delete_btn">
                <div className="d-flex footer-btn align-items-stretch justify-content-between">
                    <div className="d-flex">
                        <Button
                            variant="secondary"
                            onClick={onCancel}
                            title='Cancel'
                        >
                            Cancel
                        </Button>
                    </div>
                    {hasDocsToEdit && (
                        <div className="d-flex">
                            <Button
                                variant="success"
                                onClick={redirectToMergeSplitPage}
                                title='Continue'
                            >
                                Continue
                            </Button>
                        </div>
                    )}
                </div>
            </Modal.Footer>
        </DraggableModal>
    );
};

export default CheckLocksBeforeEditModal;
